
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddressKeys } from "./address.keys";
import { useApi } from "../../api/ApiProvider";
import notificationStore from "../Notification/notificationStore";
import { SublocalityDto } from "../../api-client";
import { useLocationId } from "../User";

export const useDeleteSublocality = () => {
  const { address: addressApi } = useApi();
  const queryClient = useQueryClient();
  const locationId = useLocationId();

  return useMutation({
    mutationFn: async (sublocalityId: string) => {
      return await addressApi.deleteSublocality(sublocalityId);
    },
    onSuccess: (_data, sublocalityId) => {
      notificationStore.showMessage(`Stadtteil erfolgreich entfernt`, "success");
      queryClient.invalidateQueries({ queryKey: AddressKeys.sublocalities.all(locationId) });
      queryClient.invalidateQueries({ queryKey: AddressKeys.patientCoordinates.all(locationId) });
    },
    onError: (error: any) => {
      notificationStore.showMessage( 
        error?.response?.data?.message || "Fehler beim Löschen des Stadtteils.",
        "error",
        error
      );
    },
  });
};

export const useCreateSublocality = () => {
  const { address: addressApi } = useApi();
  const queryClient = useQueryClient();
  const locationId = useLocationId();

  return useMutation({
    mutationFn: async (sublocalityDto: SublocalityDto) => {
    return await addressApi.createSublocality(sublocalityDto);
    },
    onSuccess: () => {
      notificationStore.showMessage("Stadtteil erfolgreich erstellt", "success");
      queryClient.invalidateQueries({ queryKey: AddressKeys.sublocalities.all(locationId) });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message ||
          "Fehler beim Erstellen des Stadtteils",
        "error",
        error
      );
    },
  });
};

export const useUpdateSublocality = () => {
  const { address: addressApi } = useApi();
  const queryClient = useQueryClient();
  const locationId = useLocationId();

  return useMutation({
    mutationFn: async ({ id, sublocalityDto }: { id: string; sublocalityDto: SublocalityDto }) => {
      return await addressApi.updateSublocality(id, sublocalityDto);
    },
    onSuccess: (_data, variables) => {
      notificationStore.showMessage(`Stadtteil erfolgreich aktualisiert`, "success");
      queryClient.invalidateQueries({ queryKey: AddressKeys.sublocalities.all(locationId) });
      queryClient.invalidateQueries({ queryKey: AddressKeys.patientCoordinates.all(locationId) });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message || "Fehler beim Aktualisieren des Stadtteils",
        "error",
        error
      );
    },
  });
};

export const useImportGeojsonSublocalities = () => {
  const { address: addressApi } = useApi();
  const queryClient = useQueryClient();
  const locationId = useLocationId();

  return useMutation({
    mutationFn: async (geojson: object) => {
      return await addressApi.importGeojsonSublocalities(locationId!, geojson);
    },
    onSuccess: () => {
      // notificationStore.showMessage(`GeoJSON-Stadtteile wurden erfolgreich importiert`, "success");
      queryClient.invalidateQueries({ queryKey: AddressKeys.sublocalities.all(locationId) });
      queryClient.invalidateQueries({ queryKey: AddressKeys.patientCoordinates.all(locationId) });
    },
    onError: (error: any) => {
      notificationStore.showMessage(
        error?.response?.data?.message || "Fehler beim Import der GeoJSON-Daten",
        "error",
        error
      );
    },
  });
};

